import React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

const IndividualProfileTabsTable = ({ tabsData, tabValueSelected, handleTabChange, orientation ='horizontal' }) => {
  return (
    <div className="tabs-table-holder">
      <Tabs
        TabIndicatorProps={{ style: { background: '#3d98ff' } }}
        value={tabValueSelected}
        onChange={handleTabChange}
        aria-label="tabs table"
        variant="scrollable"
        scrollButtons={'auto'}
        allowscrollbuttonsmobile={'true'}
        orientation={orientation}
      >
        {tabsData.map((tab, index) => {
          return (
            <Tab
              key={tab.name}
              label={tab.name}
              id={`tab-${index}`}
              aria-controls={`tabpanel-${index}`}
            />
          );
        })}
      </Tabs>

      {tabsData.map((tab, index) => {
        return (
          <div
            key={tab.value}
            role="tabpanel"
            id={`tabpanel-${index}`}
            aria-labelledby={`tabpanel-${index}`}
          >
            {tabValueSelected === index && <div>{tab.children}</div>}
          </div>
        );
      })}
    </div>
  );
};

IndividualProfileTabsTable.propTypes = {
  tabsData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  tabValueSelected: PropTypes.number.isRequired,
  handleTabChange: PropTypes.func,
  orientation: PropTypes.string,
};

export default IndividualProfileTabsTable;
